import { useState } from "react"
import { Button } from "reactstrap"
import { useAuth } from "hooks/authHook"

const ImpersonationNotice = () => {
  const { isImpersonating, originalUser, user, stopImpersonating } = useAuth()
  const [isSwitchingBack, setIsSwitchingBack] = useState(false)

  if (!isImpersonating) {
    return null
  }

  const currentLabel = user?.name || user?.username || "this account"
  const originalLabel =
    originalUser?.name || originalUser?.username || originalUser?.email || "your main account"

  const handleSwitchBack = async () => {
    if (isSwitchingBack) {
      return
    }

    setIsSwitchingBack(true)

    try {
      await stopImpersonating()
    } finally {
      setIsSwitchingBack(false)
    }
  }

  return (
    <div className="impersonation-topbar">
      <div className="impersonation-topbar__pill">
        <span className="impersonation-topbar__icon">
          <i className="mdi mdi-account-switch" />
        </span>
        <div className="impersonation-topbar__copy">
          <span className="impersonation-topbar__eyebrow">Impersonating</span>
          <span className="impersonation-topbar__title">{currentLabel}</span>
          <span className="impersonation-topbar__meta">from {originalLabel}</span>
        </div>
      </div>
      <Button
        color="dark"
        className="impersonation-topbar__button"
        onClick={handleSwitchBack}
        disabled={isSwitchingBack}
        title={`Return to ${originalLabel}`}
      >
        {isSwitchingBack ? "Switching..." : "Return"}
      </Button>
    </div>
  )
}

export default ImpersonationNotice
